module.exports = __webpack_public_path__ + "img/whiteLogo.dc0f1e88.png";